import moment from "moment";

export const HotelKeyDummy = () => {
  return {
    data: {
      booking: {
        title: "Mr",
        first_name: "Dev",
        last_name: "Admin",
        dob: "06/08/1994",
        email: "dev.admin@okkami.com",
        phone: {
          phone_id: null,
          phone_role: null,
          phone_type: null,
          phone_number: null,
          phone_country_code: "66",
          phone_number_without_code: "812345678",
        },
        avatar: {
          url: "https://i.pravatar.cc/150?img=53",
          public_id: "cit9lui4ufrseqj245sq",
          thumbnail: {
            url: "https://i.pravatar.cc/150?img=53",
          },
        },
        gender: null,
        guests: {
          adults: 3,
          children: 0,
        },
        address: {
          city_name: "Bangkok",
          address_id: null,
          address_type: "Home",
          country_of_residence: "Thailand",
          country_of_residence_code: "TH",
        },
        bed_kind: null,
        fulfillment_type_name: "pre_checkin",
        node_id: "37770",
        status: "ready_to_pre_checkin", // the status includes ready_to_pre_checkin, booking_in_the_past, pre_check_in_completed and room_is_ready
        resv_id: "237401",
        booking_id: "1234567",
        arrival_date: moment().toISOString(),
        departure_date: moment().add(1, "day").toISOString(),
        flight_arrive_time: null,
        children: [],
        currency: "USD",
        email_id: null,
        passport: {
          primary: null,
          document_id: null,
          effective_date: null,
          place_of_issue: null,
          document_number: null,
          expiration_date: null,
          country_of_issue: null,
        },
        check_in: moment().toISOString(),
        check_out: moment().add(3, "day").toISOString(),
        flight_no: null,
        room_code: "BWKV",
        room_rate: 495.0,
        profile_id: "b7f30f25-eb85-49f6-9aef-47a5bb4a90b4",
        nationality: null,
        arrival_card: null,
        total_guests: 11,
        account_exist: true,
        license_plate: null,
        advance_deposit: null,
        number_of_rooms: 1,
        pre_auth_amount: {
          total_pre_auth: 990,
          total_pre_auth_cents: 0,
        },
        nationality_code: null,
        room_description: "4 Bedroom Flat, Boardwalk View",
        special_requests: [],
        additional_guests_info: [
          {
            id: "ce228f79-f0ae-4643-b45a-5f3422ae2f09",
            email: "dev.registered@okkami.com",
            avatar: {
              url: "https://i.pravatar.cc/150?img=12",
              public_id: "jvki8bldne2fdiglfuvn",
              thumbnail: {
                url: "https://i.pravatar.cc/150?img=12",
              },
            },
            country: "US",
            children: [],
            guest_id: 8409,
            last_name: "Doe",
            first_name: "John",
            account_exist: true,
            license_plate: null,
            pre_checked_in_completed: false,
          },
          {
            id: "f86a7168-9e82-49b0-9136-b983b99d297f",
            email: "dev.new@okkami.com",
            avatar: null,
            country: "US",
            children: [],
            guest_id: 8410,
            last_name: "Hughes",
            first_name: "Isaac",
            account_exist: false,
            license_plate: null,
            pre_checked_in_completed: false,
          },
        ],
        pre_checked_in_completed: false,
      },
      pms_interface_type: "hotelkey",
      status: "ok", // the status includes finish, ok and not_acceptable
    },
  };
};
